import create from './case'
const roure = [
    // path, name, route, title, tabbar = false, keep = false
    create("/debug/:password", "debug", "debug/debug", "debug调试"),
];
export default roure

